<template>
  <div>
    <v-card>
  <RichEditor
    :remote-update-item="remoteUpdateItem"
    :remote-get-item="remoteGetItem"
    
  >
  </RichEditor>
</v-card>
  <v-expansion-panels   multiple style="margin-top:12px">
    <v-expansion-panel>
      <v-expansion-panel-header>Privacy Policy History</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card   >
      <v-card-text>
        <CRUDTable
        disableCreate
        :externalLoading="loading"
        ref="CRUDTable"
        :remoteCreateItem="remoteCreateItem"
        :remoteUpdateItem="remoteUpdateItem"
        :remoteDeleteItem="remoteDeleteItem"
        :remoteGetItem="remoteGetItem"
        :fetchList="RemoteFetchItem"
        editWith="1000px"
        :searchKeyWord="searchKeyWord"
        :formConfig="formConfig"
        :inputConfigs="inputConfigs"
        @reset="handleReset"
        @openEditDialog="onEditDialog"
      >
      </CRUDTable>
      </v-card-text>
    </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>

  </v-expansion-panels>
</div>


</template>

<script>
import { createItem, deleteItem, fetchList, getItem, updateItem ,GetLatestRecord } from '@/api/privacyPolicy'
import RichEditor from '@/components/RichEditor/RichEditor'

import CRUDTable from '@/components/CRUD/CRUDTable'
import { ref } from 'vue'

export default {
  name: 'Privacy Policy',
  components: {
    RichEditor,
    CRUDTable,
  },
  methods: {
    handleReset() {
      console.log('handleReset')
    },
    onEditDialog(action) {
      console.log('action', action)
    },
    handleSavingContent() {
      // You have the content to save
      console.log(this.content)
      updateItem({ id: this.record, content: this.content }).then(response => {
        console.log(this.content)
      }).catch(err => {})
    },
  },
  setup() {


    // let formConfig = {
    //     title: 'TermsConidition',
    //     headers: [
    //       { value: 'id', text: 'Id' },
    //       { value: 'description', text: 'description' },
    //     ],
 
    //   }

      let formConfig = {
        title: 'Privacy Policy',
        headers: [
          { value: 'id', text: 'Id' },
          { value: 'content', text: 'Content' },
   
        ],
      }

      const loading = ref(false)
      const searchKeyWord = ref('')

    return {
      remoteGetItem: GetLatestRecord,
      remoteUpdateItem: updateItem,
      // RemoteGetItem : fetchList, 
      // RemoteUpdateItem : fetchList,
      // RemoteDeleteItem : fetchList,
      RemoteFetchItem : fetchList,


      loading, 
      searchKeyWord, 
      inputConfigs: [
  
        ],

        formConfig: formConfig,
    }

    
  },
}
</script>

  <style lang="scss">
  @import '@core/preset/preset/apps/user.scss';
  </style>

  <style scoped>
.center {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top : 12px;

}
  </style>
